import { podcastEn } from "./podcast/en";

export const translations = {
  en: {
    podcast: podcastEn,
  },
} as const;

export type SupportedLanguage = keyof typeof translations;
